<template>
	<v-menu :model-value="notification?.active"
		class="d-flex justify-space-around mt-16"
		:persistent="true"
		:close-on-content-click="false"
	>
		<v-alert :model-value="notification?.active"
			:type="notificationType"
			:title="notification.title"
			:color="notification?.type"
			:rounded="true"
			:closable="false"
			density="compact"
			:max-width="500"
		>
			<span v-html="notification.message"/>
		</v-alert>
	</v-menu>
</template>

<script>
/* Enums */
import {NotificationTypes} from "@/enums/NotificationTypes";
export default {
	name: "StickyNotification",

	computed: {
		notification() {
			return this.$store.getters.persistentNotifications();
		},

		notificationType() {
			return NotificationTypes[this.notification?.type];
		}
	}
}
</script>

<style scoped lang="scss">

</style>